import { render, staticRenderFns } from "./CallToActionBlock.vue?vue&type=template&id=f398dfd8"
import script from "./CallToActionBlock.vue?vue&type=script&lang=js"
export * from "./CallToActionBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports